// Bloque con brillo que ocupa el lugar del contenido mientras carga (estilos .lp-skel en index.css).
// Con className toma el tamaño de esa clase, así copia exacto al elemento real.
const Skeleton = ({ width, height, radius, circle, className = "", style }) => {
    return (
    <span className={`lp-skel ${className}`} aria-hidden="true" style={{ width, height: height ?? (className ? undefined : 14), borderRadius: circle ? "50%" : radius, ...style }}></span>  )
}

// Envuelve una pantalla de skeletons y avisa a los lectores de pantalla que está cargando.
export const SkeletonScreen = ({ label = "Cargando…", className, children }) => {
    return (
    <div className={className} role="status" aria-busy="true">
        <span className="lp-skel-sr">{label}</span>
        {children}
    </div>  )
}

export default Skeleton
